
export default {
  props: {
    imgSrc: {
      // 正式图片路径
      type: String,
      default: ''
    },
    type: {
      // 模版类型 0--160*60;1---20*20;2---集市；3----文章
      type: String,
      default: '0'
    },
    height: {
      // 图片宽度
      type: String,
      default: '100%'
    },
    alt: {
      // img alt属性的值
      type: String,
      default: ''
    },
    lzshow: {
      // 是否需要懒加载 true需要---false不需要
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      src: this.lzshow ? '' : this.imgSrc
    }
  },
  computed: {
    defaultImg() {
      // 模版选择
      let ss = ''
      if (this.type == '0') {
        ss = 'https://resources1.interface003.com/web20/img/default/Avatar.png'
      } else if (this.type == '1') {
        // 头像
        ss = 'https://resources1.interface003.com/web20/img/default/20-20.png'
      } else if (this.type == '2') {
        // 集市
        ss = 'https://resources1.interface003.com/web20/img/default/dealer-default.png'
      } else if (this.type == '3') {
        // 文章
        ss = 'https://resources1.interface003.com/web20/img/default/article.png'
      } else if (this.type == '4') {
        // 用户头像
        ss = 'https://resources1.interface003.com/web20/img/default/avader.png'
      } else if (this.type == '5') {
        // 首页广告
        ss = 'https://resources1.interface003.com/web20/img/default/ad.png'
      } else if (this.type == '6') {
        // 猜你喜欢
        ss = 'https://resources1.interface003.com/web20/img/default/103_60.png'
      } else if (this.type == '7') {
        // 实勘
        ss = 'https://resources1.interface003.com/web20/img/default/survey.png'
      }
      return ss
    }
  },
  methods: {
    updateimg(imgsrc) {
      this.src = imgsrc
    }
  }
}
